export default {
  CHAMPION: 'CHAMPION',
  CHALLENGER: 'CHALLENGER'
}
